// Caja de búsqueda estándar de la plataforma: input con una ✕ para limpiar
// lo escrito. Úsalo en cualquier buscador nuevo para que todos se comporten igual.
import type { InputHTMLAttributes, JSX } from "react";

export function SearchInput(
  { value, onValueChange, onClear, className, ...rest }:
  { value: string; onValueChange: (v: string) => void; onClear?: () => void; className?: string }
  & Omit<InputHTMLAttributes<HTMLInputElement>, "value" | "onChange" | "className">,
): JSX.Element {
  return (
    <div className={`relative ${className ?? ""}`}>
      <input
        className="input w-full pr-8"
        value={value}
        autoComplete="off"
        placeholder="Buscar…"
        onChange={(e) => onValueChange(e.target.value)}
        {...rest}
      />
      {value && (
        <button
          type="button"
          aria-label="Limpiar"
          className="absolute right-2 top-1/2 -translate-y-1/2 text-ink-muted hover:text-ink-secondary text-sm"
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => { onValueChange(""); onClear?.(); }}
        >✕</button>
      )}
    </div>
  );
}
